export class SeatApiModel {
  id: string;
  rowSymbol: string;
  seatSymbol: string;
}
